angular.module('olivioConfiguratorApp')
  .controller('DesignInfoCtrl', function ($rootScope, $scope, Model, Data, DesignCtrlService, AdvancedLoginService, OLIVIOMainFactory, StepService, ColorSelectService, Storage, $window, $location, $translate) {
    console.log('init DesignInfoCtrl mm');
    var intRegex = /^\d+$/;

    $scope.OLIVIO = OLIVIO;
    $scope.model = Model.model;
    $scope.data = Data;
    $scope.$translate = $translate;


    $scope.cmodel = OLIVIO.cmodel;
    $scope.designCtrlService = DesignCtrlService;

    $scope.getCurrentStep = StepService.getCurrentStep;
    //$scope.getCurrentStep = function() {
    //  console.log('DesignInfoCtrl.getCurrentStep: ', StepService.getCurrentStep());
    //  return StepService.getCurrentStep();
    //};

    //$scope.mastSizeOptions = [];
    //$scope.currentMastSizeOption = null;

    $scope.mainFactory = OLIVIOMainFactory;

    $scope.candelabraLumDegreeOptions = [120, 180];


    //

    $scope.topLumHeightChangeTimeout = null;
    $scope.bottomLumHeightChangeTimeout = null;
    $scope.rotationChangeTimeout = null;
    $scope.startDegreeChangeTimeout = null;


    // Werte mit aktualisierungen

    $scope.mastSizemm = $scope.model.design.height;
    $scope.lumCount = $scope.cmodel.currentLumCount;
    $scope.lumType = Data.getLumOption($scope.model.design.lumtype);
    $scope.bracketOption = Data.getLumOption($scope.model.design.beamtype);
    $scope.chargingType = Data.getChargingTypeOption(Model.model.charging.type);
    $scope.chargingPower = Data.getChargingPowerOption(Model.model.charging.power);
    $scope.mastMaterial = Data.getColorSelectOption($scope.model.design.colorIds.mast).wood ? 'w' : 'm';

    function setAvailableMastColors() {
      $scope.mastColors =
        ($scope.mastMaterial === 'w') ?
          Data.woodColorSelectOptions :
          Data.metalColorSelectOptions.concat(Data.outsideColorSelectOptions);
    }
    setAvailableMastColors();

    // watch for changes of height
    $scope.$watch('model.design.height', function (newValue, oldValue) {
      console.log('designinfo WATCH model.design.height', Model.model.product.id, Model.model.design.height, OLIVIO.cmodel.mastSizesmm, OLIVIO.cmodel.mastSizeIndex, OLIVIO.cmodel.mastSizesmm[OLIVIO.cmodel.mastSizeIndex])
      $scope.mastSizemm = Model.model.design.height;
    });
    // watch for changes of lum count
    $scope.$watch('cmodel.currentLumCount', function (newValue, oldValue) {
      console.log('designinfo WATCH cmodel.currentLumCount', Model.model.product.id, Model.model.design.height, OLIVIO.cmodel.mastSizesmm, OLIVIO.cmodel.mastSizeIndex, OLIVIO.cmodel.mastSizesmm[OLIVIO.cmodel.mastSizeIndex],
        $scope.lumCount + ' -> ' + $scope.cmodel.currentLumCount, $scope.lumCount === parseInt($scope.lumCount), $scope.cmodel.currentLumCount === parseInt($scope.cmodel.currentLumCount));
      $scope.lumCount = $scope.cmodel.currentLumCount;
    });
    // watch for lumType
    $scope.$watch('model.design.lumtype', function(newValue, oldValue) {
      $scope.lumType = Data.getLumOption($scope.model.design.lumtype);
    });
    $scope.$watch('designCtrlService.advancedEditingLumId', function(newValue, oldValue) {
      //console.log('designinfo  WATCH designCtrlService.advancedEditingLumId', (OLIVIO.cmodel.isAdvancedMode() && DesignCtrlService.advancedEditingLumId > -1),DesignCtrlService.advancedEditingLumId, (OLIVIO.cmodel.isAdvancedMode() && DesignCtrlService.advancedEditingLumId > -1)?$scope.model.design.individualHeads[DesignCtrlService.advancedEditingLumId]:'--');
      if(OLIVIO.cmodel.isAdvancedMode() && DesignCtrlService.advancedEditingLumId > -1) {
        $scope.lumType = Data.getLumOption($scope.model.design.individualHeads[DesignCtrlService.advancedEditingLumId]);
      }
    });
    // watch for bracketOption
    $scope.$watch('model.design.beamtype' , function(nV, oV) {
      //console.log('designinfo WATCH beamtType -> bracketOption: ', $scope.model.design.beamtype);
        $scope.bracketOption = Data.getBracketOption($scope.model.design.beamtype);
    });
    // watches for charging
    $scope.$watch('model.charging.type', function(nV, oV) {
      //console.log('designinfo WATCH model.charging.type', Model.model.charging.type, $scope.model.charging.type, Data.getChargingTypeOption(Model.model.charging.type));
      $scope.chargingType = Data.getChargingTypeOption(Model.model.charging.type);
    });
    $scope.$watch('model.charging.power', function(nV, oV) {
      //console.log('designinfo WATCH model.charging.power', Model.model.charging.power, $scope.model.charging.power, Data.getChargingPowerOption(Model.model.charging.power));
      $scope.chargingPower = Data.getChargingPowerOption(Model.model.charging.power);
    });
    // watch for pole color to derive pole material
    $scope.$watch('model.design.colorIds.mast', function (nV, oV) {
      // console.log('DesignInfoCtrl watch model.design.colorIds.mast', {
      //   mast: $scope.model.design.colorIds.mast,
      //   o: Data.getColorSelectOption($scope.model.design.colorIds.mast),
      //   mastMaterial: (Data.getColorSelectOption($scope.model.design.colorIds.mast).wood ? 'w' : 'm'),
      //   oV, nV
      // });
      $scope.mastMaterial = Data.getColorSelectOption($scope.model.design.colorIds.mast).wood ? 'w' : 'm';
      setAvailableMastColors();
    });

    // Event-Handler für HTML
    $scope.mastSizeMouseDown = function() {
      //console.log('mastSizeMouseDown', Model.model.design.height, $scope.mastSizemm,  OLIVIO.cmodel.mastSizeIndex,  OLIVIO.cmodel.mastSizesmm[OLIVIO.cmodel.mastSizeIndex]);
      //console.log('+designinfo editPole'+OLIVIOMainFactory.getCurrent());
      if(OLIVIOMainFactory.getCurrent())
        OLIVIOMainFactory.getCurrent().editPole();
    };


    $scope.mastSizeChange = function (a,b,c) {
      //console.log('mastSizeChange', 'to:', $scope.mastSizemm, 'from:', OLIVIO.cmodel.mastSizeIndex,  OLIVIO.cmodel.mastSizesmm[OLIVIO.cmodel.mastSizeIndex],a,b,c);
      var mastOption = Data.getMastOption(Model.model.product.id)
      var mindex = mastOption.mastSizesmm.indexOf(parseInt($scope.mastSizemm));
      mindex = mindex < 0 ? 0: mindex;
      $scope.model.design.height = $scope.cmodel.mastSizesmm[$scope.cmodel.mastSizeIndex];
      $scope.model.design.diameter = mastOption.mastDiametermm[mindex];
      OLIVIO.cmodel.setMastHeightByIndex(mindex, true); // true ruft updateFromSVG auf

      //DesignCtrl.$scope.updateVisibleLums(); // wird jetzt von updateFromSVG() mit erledigt

      if ($scope.model.userOptions.advanced === true && OLIVIOMainFactory.getCurrent()) {
        OLIVIOMainFactory.getCurrent().setEditAdvanced(true);
      }
    };

    $scope.lumTopBottomMouseDown = function() {
      console.log('lumTopBottomMouseDown', $scope.main === OLIVIOMainFactory.getCurrent(), $scope.main);
      $scope.main.editLums();
    };

    $scope.lumCountChange = function () {
      var count = parseInt($scope.lumCount);
      if(!OLIVIO.cmodel.isAdvancedMode()) {
        var maxCount = OLIVIO.cmodel.getMaxPossibleLums();
        count = count < maxCount ? count : maxCount;
      }
      var oldCount = $scope.model.design.lumcount;
      OLIVIO.cmodel.setLumCount(count); // löst indirekt via AngularCallback bereits DesignCtrl.updateVisibleLums aus
      $scope.model.design.lumcount = OLIVIO.cmodel.currentLumCount; // watch löst erneute updateVisibleLums aus
      $scope.lumCount = OLIVIO.cmodel.currentLumCount;
      if(oldCount < $scope.lumCount) {
        DesignCtrlService.ensureLumData();
      }
    };

    $scope.degreeDropDownChange = function () {
      $scope.model.design.topToBottomRotation = parseInt($scope.model.design.topToBottomRotation);
      OLIVIO.cmodel.arrangeLumRotations($scope.model.design.topToBottomRotation);
      //OLIVIO.cmodel.setLumCount($scope.model.design.lumcount);
    };

    $scope.lumTypeChange = function () {
      if ($scope.lumType) {
        if(DesignCtrlService.lumTypeSelectorSetup) {
          DesignCtrlService.lumTypeSelectorSetup.blockcallback = true;
          DesignCtrlService.lumTypeSelectorSetup.goto(DesignCtrlService.getIndexForLumType($scope.lumType.id) + 1);
        }
        DesignCtrlService.changeLumType($scope.lumType.id);
      }
    };

    $scope.bracketTypeChange = function () {
      if ($scope.bracketOption) {
        $scope.model.design.beamtype = $scope.bracketOption.id;
        if(DesignCtrlService.bracketSelectorSetup) {
          DesignCtrlService.bracketSelectorSetup.blockcallback = true;
          DesignCtrlService.bracketSelectorSetup.goto(DesignCtrlService.getIndexForBeamType($scope.bracketOption.id) + 1);
        }
        DesignCtrlService.changeBracket($scope.model.design.beamtype);
      }
    };


    $scope.topLumHeightUpdate = function () {
      clearTimeout($scope.topLumHeightChangeTimeout);
      if (intRegex.test($scope.model.design.toplumiereheight)) {
        OLIVIO.cmodel.startArrangingLumPositions();
        OLIVIO.cmodel.setTopLumHeightBymm($scope.model.design.toplumiereheight);
      } else {
        $scope.model.design.toplumiereheight = 12000;
        OLIVIO.cmodel.startArrangingLumPositions();
        OLIVIO.cmodel.setBottomLumHeightBymm($scope.model.design.bottomlumiereheight);
      }
    };

    $scope.topLumHeightChange = function () {
      clearTimeout($scope.topLumHeightChangeTimeout);
      $scope.topLumHeightChangeTimeout = setTimeout($scope.topLumHeightUpdate, 2000);
    };

    $scope.bottomLumHeightUpdate = function () {
      clearTimeout($scope.bottomLumHeightChangeTimeout);
      if (intRegex.test($scope.model.design.bottomlumiereheight)) {
        OLIVIO.cmodel.startArrangingLumPositions();
        OLIVIO.cmodel.setBottomLumHeightBymm($scope.model.design.bottomlumiereheight);
      } else {
        // TODO alten Wert speichern und nur gültige Eingaben ins Model schreiben, damit es auch bei nur 1 Lum funktioniert.
        $scope.model.design.bottomlumiereheight = $scope.model.design.individualHeights.length > 1 ? $scope.model.design.individualHeights[$scope.model.design.individualHeights.length - 1] : 0;
        console.log('bottomLumHeightUpdate, invalid input', typeof ($scope.model.design.bottomlumiereheight), $scope.model.design.bottomlumiereheight,$scope.model.design.individualHeights );
        OLIVIO.cmodel.startArrangingLumPositions();
        OLIVIO.cmodel.setBottomLumHeightBymm($scope.model.design.bottomlumiereheight);

      }
    };

    $scope.bottomLumHeightChange = function () {
      clearTimeout($scope.bottomLumHeightChangeTimeout);
      $scope.bottomLumHeightChangeTimeout = setTimeout($scope.bottomLumHeightUpdate, 2000);
    };



    $scope.startDegreeUpdate = function () {
      console.log('startDegreeUpdate '+intRegex.test($scope.model.design.startDegree));
      clearTimeout($scope.startDegreeChangeTimeout);
      if (intRegex.test($scope.model.design.startDegree)) {
        OLIVIO.cmodel.setStartRotationMathematical($scope.model.design.startDegree);
      } else {
        $scope.model.design.startDegree = Math.round(OLIVIO.cmodel.getStartRotationMathematical());
        console.log($scope.model.design.topToBottomRotation,  $scope.model.design.topToBottomRotation === parseInt($scope.model.design.topToBottomRotation), OLIVIO.cmodel.getTopToBottomRotation(), OLIVIO.cmodel.getTopToBottomRotation() === parseInt(OLIVIO.cmodel.getTopToBottomRotation()));

        OLIVIO.cmodel.setStartRotationMathematical($scope.model.design.startDegree);
      }
    };

    $scope.startDegreeChange = function () {
      clearTimeout($scope.startDegreeChangeTimeout);
      $scope.startDegreeChangeTimeout = setTimeout($scope.startDegreeUpdate, 1500);
      //console.log($scope.model.design.topToBottomRotation);
    };


    $scope.rotationUpdate = function () {
      console.log('rotationUpdate ' + intRegex.test($scope.model.design.topToBottomRotation));
      clearTimeout($scope.rotationChangeTimeout);
      if (intRegex.test($scope.model.design.topToBottomRotation)) {
        OLIVIO.cmodel.startArrangingLumPositions();
        OLIVIO.cmodel.arrangeLumRotations($scope.model.design.topToBottomRotation);
      } else {
        $scope.model.design.topToBottomRotation = OLIVIO.cmodel.getTopToBottomRotation();
        console.log($scope.model.design.topToBottomRotation,  $scope.model.design.topToBottomRotation === parseInt($scope.model.design.topToBottomRotation), OLIVIO.cmodel.getTopToBottomRotation(), OLIVIO.cmodel.getTopToBottomRotation() === parseInt(OLIVIO.cmodel.getTopToBottomRotation()));

        OLIVIO.cmodel.startArrangingLumPositions();
        OLIVIO.cmodel.arrangeLumRotations($scope.model.design.topToBottomRotation);
      }
    };

    $scope.rotationChange = function () {
      clearTimeout($scope.rotationChangeTimeout);
      $scope.rotationChangeTimeout = setTimeout($scope.rotationUpdate, 1500);
      //console.log($scope.model.design.topToBottomRotation);
    };


    $scope.chargingCountChange = function() {
      //console.log('chargingCountChange ', StepService.getCurrentStep() , StepService.getCurrentStep().view !== 'charging');

      if(Data.chargingArrangementOptions[Model.model.charging.count][Model.model.charging.arrangement] === undefined) {
        Model.model.charging.arrangement = 0;
      }

      if(!Model.model.charging.done && Model.model.charging.count > 0 && StepService.getCurrentStep().view !== 'charging') { // erste Klausel: nur automatisch umschalten, wenn noch nie in charging gewesen
        Model.model.charging.done = true;
        StepService.gotoStep('charging');
      }
    };

    $scope.chargingTypeChange = function() {
      console.log('chargingTypeChange '+$scope.chargingType.id, $scope.chargingType);
      Model.model.charging.type = $scope.chargingType.id;
    };

    $scope.chargingPowerChange = function() {
      Model.model.charging.power = $scope.chargingPower.id;
    };

    // angular ist so buggy, daher fix via zwei exta change-funktionen
    $scope.mastMaterialChangeM = function () {
      $scope.mastMaterial = 'm';
      $scope.mastMaterialChange();
    }
    $scope.mastMaterialChangeW = function () {
      $scope.mastMaterial = 'w';
      $scope.mastMaterialChange();
    }
    $scope.mastMaterialChange = function () {
      var old = Data.getColorSelectOption($scope.model.design.colorIds.mast).wood ? 'w' : 'm';
      console.warn('DesignInfoCtrl mastMaterialChange', {changed: old !== $scope.mastMaterial, from: old, to: $scope.mastMaterial, scope: $scope, rs: $rootScope});
      if(old !== $scope.mastMaterial) {
        setAvailableMastColors();
        $scope.model.design.colorIds.mast = ($scope.mastMaterial === 'w') ?
          'woodredwood' :
          'seluxGraphite';
      }
    }

    $scope.nextStep = function () {
      $scope.model.design.done = true;
      StepService.nextStep();
    };


  });
